import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-zoom-integration',
  templateUrl: './zoom-integration.component.html',
  styleUrls: ['./zoom-integration.component.scss']
})
export class ZoomIntegrationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
